module.exports = __webpack_public_path__ + "static/media/Finnovex-West-Africa-2024 copy 2.2c2cff06.png";